import { render, staticRenderFns } from "./UpdateGlobalSettingPage.vue?vue&type=template&id=a641d954"
import script from "./UpdateGlobalSettingPage.vue?vue&type=script&lang=js"
export * from "./UpdateGlobalSettingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports